export const CountriesList = [
  { "id": 1, "name": "NIGERIA", "code": "NIGERIA" },
  { "id": 2, "name": "AFGHANISTAN", "code": "AFGHANISTAN" },
  { "id": 3, "name": "ÅLAND ISLANDS", "code": "ÅLAND ISLANDS" },
  { "id": 4, "name": "ALBANIA", "code": "ALBANIA" },
  { "id": 5, "name": "ALGERIA", "code": "ALGERIA" },
  { "id": 6, "name": "AMERICAN SAMOA", "code": "AMERICAN SAMOA" },
  { "id": 7, "name": "ANDORRA", "code": "ANDORRA" },
  { "id": 8, "name": "ANGOLA", "code": "ANGOLA" },
  { "id": 9, "name": "ANGUILLA", "code": "ANGUILLA" },
  { "id": 10, "name": "ANTARCTICA", "code": "ANTARCTICA" },
  { "id": 11, "name": "ANTIGUA AND BARBUDA", "code": "ANTIGUA AND BARBUDA" },
  { "id": 12, "name": "ARGENTINA", "code": "ARGENTINA" },
  { "id": 13, "name": "ARMENIA", "code": "ARMENIA" },
  { "id": 14, "name": "ARUBA", "code": "ARUBA" },
  { "id": 15, "name": "AUSTRALIA", "code": "AUSTRALIA" },
  { "id": 16, "name": "AUSTRIA", "code": "AUSTRIA" },
  { "id": 17, "name": "AZERBAIJAN", "code": "AZERBAIJAN" },
  { "id": 18, "name": "BAHAMAS", "code": "BAHAMAS" },
  { "id": 19, "name": "BAHRAIN", "code": "BAHRAIN" },
  { "id": 20, "name": "BANGLADESH", "code": "BANGLADESH" },
  { "id": 21, "name": "BARBADOS", "code": "BARBADOS" },
  { "id": 22, "name": "BELARUS", "code": "BELARUS" },
  { "id": 23, "name": "BELGIUM", "code": "BELGIUM" },
  { "id": 24, "name": "BELIZE", "code": "BELIZE" },
  { "id": 25, "name": "BENIN", "code": "BENIN" },
  { "id": 26, "name": "BERMUDA", "code": "BERMUDA" },
  { "id": 27, "name": "BHUTAN", "code": "BHUTAN" },
  { "id": 28, "name": "BOLIVIA", "code": "BOLIVIA, PLURINATIONAL STATE OF" },
  { "id": 29, "name": "BOSNIA AND HERZEGOVINA", "code": "BOSNIA AND HERZEGOVINA" },
  { "id": 30, "name": "BOTSWANA", "code": "BOTSWANA" },
  { "id": 31, "name": "BOUVET ISLAND", "code": "BOUVET ISLAND" },
  { "id": 32, "name": "BRAZIL", "code": "BRAZIL" },
  { "id": 33, "name": "BRITISH INDIAN OCEAN TERRITORY", "code": "BRITISH INDIAN OCEAN TERRITORY" },
  { "id": 34, "name": "BRUNEI DARUSSALAM", "code": "BRUNEI DARUSSALAM" },
  { "id": 35, "name": "BULGARIA", "code": "BULGARIA" },
  { "id": 36, "name": "BURKINA FASO", "code": "BURKINA FASO" },
  { "id": 37, "name": "BURUNDI", "code": "BURUNDI" },
  { "id": 38, "name": "CAMBODIA", "code": "CAMBODIA" },
  { "id": 39, "name": "CAMEROON", "code": "CAMEROON" },
  { "id": 40, "name": "CANADA", "code": "CANADA" },
  { "id": 41, "name": "CAPE VERDE", "code": "CAPE VERDE" },
  { "id": 42, "name": "CAYMAN ISLANDS", "code": "CAYMAN ISLANDS" },
  { "id": 43, "name": "CENTRAL AFRICAN REPUBLIC", "code": "CENTRAL AFRICAN REPUBLIC" },
  { "id": 44, "name": "CHAD", "code": "CHAD" },
  { "id": 45, "name": "CHILE", "code": "CHILE" },
  { "id": 46, "name": "CHINA", "code": "CHINA" },
  { "id": 47, "name": "CHRISTMAS ISLAND", "code": "CHRISTMAS ISLAND" },
  { "id": 48, "name": "COCOS (KEELING) ISLANDS", "code": "COCOS (KEELING) ISLANDS" },
  { "id": 49, "name": "COLOMBIA", "code": "COLOMBIA" },
  { "id": 50, "name": "COMOROS", "code": "COMOROS" },
  { "id": 51, "name": "CONGO", "code": "CONGO" },
  { "id": 52, "name": "CONGO", "code": "CONGO, THE DEMOCRATIC REPUBLIC OF THE" },
  { "id": 53, "name": "COOK ISLANDS", "code": "COOK ISLANDS" },
  { "id": 54, "name": "COSTA RICA", "code": "COSTA RICA" },
  { "id": 55, "name": "CÔTE D'IVOIRE", "code": "CÔTE D'IVOIRE" },
  { "id": 56, "name": "CROATIA", "code": "CROATIA" },
  { "id": 57, "name": "CUBA", "code": "CUBA" },
  { "id": 58, "name": "CYPRUS", "code": "CYPRUS" },
  { "id": 59, "name": "CZECH REPUBLIC", "code": "CZECH REPUBLIC" },
  { "id": 60, "name": "DENMARK", "code": "DENMARK" },
  { "id": 61, "name": "DJIBOUTI", "code": "DJIBOUTI" },
  { "id": 62, "name": "DOMINICA", "code": "DOMINICA" },
  { "id": 63, "name": "DOMINICAN REPUBLIC", "code": "DOMINICAN REPUBLIC" },
  { "id": 64, "name": "ECUADOR", "code": "ECUADOR" },
  { "id": 65, "name": "EGYPT", "code": "EGYPT" },
  { "id": 66, "name": "EL SALVADOR", "code": "EL SALVADOR" },
  { "id": 67, "name": "EQUATORIAL GUINEA", "code": "EQUATORIAL GUINEA" },
  { "id": 68, "name": "ERITREA", "code": "ERITREA" },
  { "id": 69, "name": "ESTONIA", "code": "ESTONIA" },
  { "id": 70, "name": "ETHIOPIA", "code": "ETHIOPIA" },
  { "id": 71, "name": "FALKLAND ISLANDS (MALVINAS)", "code": "FALKLAND ISLANDS (MALVINAS)" },
  { "id": 72, "name": "FAROE ISLANDS", "code": "FAROE ISLANDS" },
  { "id": 73, "name": "FIJI", "code": "FIJI" },
  { "id": 74, "name": "FINLAND", "code": "FINLAND" },
  { "id": 75, "name": "FRANCE", "code": "FRANCE" },
  { "id": 76, "name": "FRENCH GUIANA", "code": "FRENCH GUIANA" },
  { "id": 77, "name": "FRENCH POLYNESIA", "code": "FRENCH POLYNESIA" },
  { "id": 78, "name": "FRENCH SOUTHERN TERRITORIES", "code": "FRENCH SOUTHERN TERRITORIES" },
  { "id": 79, "name": "GABON", "code": "GABON" },
  { "id": 80, "name": "GAMBIA", "code": "GAMBIA" },
  { "id": 81, "name": "GEORGIA", "code": "GEORGIA" },
  { "id": 82, "name": "GERMANY", "code": "GERMANY" },
  { "id": 83, "name": "GHANA", "code": "GHANA" },
  { "id": 84, "name": "GIBRALTAR", "code": "GIBRALTAR" },
  { "id": 85, "name": "GREECE", "code": "GREECE" },
  { "id": 86, "name": "GREENLAND", "code": "GREENLAND" },
  { "id": 87, "name": "GRENADA", "code": "GRENADA" },
  { "id": 88, "name": "GUADELOUPE", "code": "GUADELOUPE" },
  { "id": 89, "name": "GUAM", "code": "GUAM" },
  { "id": 90, "name": "GUATEMALA", "code": "GUATEMALA" },
  { "id": 91, "name": "GUERNSEY", "code": "GUERNSEY" },
  { "id": 92, "name": "GUINEA", "code": "GUINEA" },
  { "id": 93, "name": "GUINEA-BISSAU", "code": "GUINEA-BISSAU" },
  { "id": 94, "name": "GUYANA", "code": "GUYANA" },
  { "id": 95, "name": "HAITI", "code": "HAITI" },
  { "id": 96, "name": "HEARD ISLAND AND MCDONALD ISLANDS", "code": "HEARD ISLAND AND MCDONALD ISLANDS" },
  { "id": 97, "name": "HOLY SEE (VATICAN CITY STATE)", "code": "HOLY SEE (VATICAN CITY STATE)" },
  { "id": 98, "name": "HONDURAS", "code": "HONDURAS" },
  { "id": 99, "name": "HONG KONG", "code": "HONG KONG" },
  { "id": 100, "name": "HUNGARY", "code": "HUNGARY" },
  { "id": 101, "name": "ICELAND", "code": "ICELAND" },
  { "id": 102, "name": "INDIA", "code": "INDIA" },
  { "id": 103, "name": "INDONESIA", "code": "INDONESIA" },
  { "id": 104, "name": "IRAN", "code": "IRAN, ISLAMIC REPUBLIC OF" },
  { "id": 105, "name": "IRAQ", "code": "IRAQ" },
  { "id": 106, "name": "IRELAND", "code": "IRELAND" },
  { "id": 107, "name": "ISLE OF MAN", "code": "ISLE OF MAN" },
  { "id": 108, "name": "ISRAEL", "code": "ISRAEL" },
  { "id": 109, "name": "ITALY", "code": "ITALY" },
  { "id": 110, "name": "JAMAICA", "code": "JAMAICA" },
  { "id": 111, "name": "JAPAN", "code": "JAPAN" },
  { "id": 112, "name": "JERSEY", "code": "JERSEY" },
  { "id": 113, "name": "JORDAN", "code": "JORDAN" },
  { "id": 114, "name": "KAZAKHSTAN", "code": "KAZAKHSTAN" },
  { "id": 115, "name": "KENYA", "code": "KENYA" },
  { "id": 116, "name": "KIRIBATI", "code": "KIRIBATI" },
  { "id": 117, "name": "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF", "code": "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF" },
  { "id": 118, "name": "KOREA, REPUBLIC OF", "code": "KOREA, REPUBLIC OF" },
  { "id": 119, "name": "KUWAIT", "code": "KUWAIT" },
  { "id": 120, "name": "KYRGYZSTAN", "code": "KYRGYZSTAN" },
  { "id": 121, "name": "LAO PEOPLE'S DEMOCRATIC REPUBLIC", "code": "LAO PEOPLE'S DEMOCRATIC REPUBLIC" },
  { "id": 122, "name": "LATVIA", "code": "LATVIA" },
  { "id": 123, "name": "LEBANON", "code": "LEBANON" },
  { "id": 124, "name": "LESOTHO", "code": "LESOTHO" },
  { "id": 125, "name": "LIBERIA", "code": "LIBERIA" },
  { "id": 126, "name": "LIBYAN ARAB JAMAHIRIYA", "code": "LIBYAN ARAB JAMAHIRIYA" },
  { "id": 127, "name": "LIECHTENSTEIN", "code": "LIECHTENSTEIN" },
  { "id": 128, "name": "LITHUANIA", "code": "LITHUANIA" },
  { "id": 129, "name": "LUXEMBOURG", "code": "LUXEMBOURG" },
  { "id": 130, "name": "MACAO", "code": "MACAO" },
  { "id": 131, "name": "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF", "code": "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF" },
  { "id": 132, "name": "MADAGASCAR", "code": "MADAGASCAR" },
  { "id": 133, "name": "MALAWI", "code": "MALAWI" },
  { "id": 134, "name": "MALAYSIA", "code": "MALAYSIA" },
  { "id": 135, "name": "MALDIVES", "code": "MALDIVES" },
  { "id": 136, "name": "MALI", "code": "MALI" },
  { "id": 137, "name": "MALTA", "code": "MALTA" },
  { "id": 138, "name": "MARSHALL ISLANDS", "code": "MARSHALL ISLANDS" },
  { "id": 139, "name": "MARTINIQUE", "code": "MARTINIQUE" },
  { "id": 140, "name": "MAURITANIA", "code": "MAURITANIA" },
  { "id": 141, "name": "MAURITIUS", "code": "MAURITIUS" },
  { "id": 142, "name": "MAYOTTE", "code": "MAYOTTE" },
  { "id": 143, "name": "MEXICO", "code": "MEXICO" },
  { "id": 144, "name": "MICRONESIA, FEDERATED STATES OF", "code": "MICRONESIA, FEDERATED STATES OF" },
  { "id": 145, "name": "MOLDOVA, REPUBLIC OF", "code": "MOLDOVA, REPUBLIC OF" },
  { "id": 146, "name": "MONACO", "code": "MONACO" },
  { "id": 147, "name": "MONGOLIA", "code": "MONGOLIA" },
  { "id": 148, "name": "MONTENEGRO", "code": "MONTENEGRO" },
  { "id": 149, "name": "MONTSERRAT", "code": "MONTSERRAT" },
  { "id": 150, "name": "MOROCCO", "code": "MOROCCO" },
  { "id": 151, "name": "MOZAMBIQUE", "code": "MOZAMBIQUE" },
  { "id": 152, "name": "MYANMAR", "code": "MYANMAR" },
  { "id": 153, "name": "NAMIBIA", "code": "NAMIBIA" },
  { "id": 154, "name": "NAURU", "code": "NAURU" },
  { "id": 155, "name": "NEPAL", "code": "NEPAL" },
  { "id": 156, "name": "NETHERLANDS", "code": "NETHERLANDS" },
  { "id": 157, "name": "NETHERLANDS ANTILLES", "code": "NETHERLANDS ANTILLES" },
  { "id": 158, "name": "NEW CALEDONIA", "code": "NEW CALEDONIA" },
  { "id": 159, "name": "NEW ZEALAND", "code": "NEW ZEALAND" },
  { "id": 160, "name": "NICARAGUA", "code": "NICARAGUA" },
  { "id": 161, "name": "NIGER", "code": "NIGER" },
  { "id": 162, "name": "NIUE", "code": "NIUE" },
  { "id": 163, "name": "NORFOLK ISLAND", "code": "NORFOLK ISLAND" },
  { "id": 164, "name": "NORTHERN MARIANA ISLANDS", "code": "NORTHERN MARIANA ISLANDS" },
  { "id": 165, "name": "NORWAY", "code": "NORWAY" },
  { "id": 166, "name": "OMAN", "code": "OMAN" },
  { "id": 167, "name": "PAKISTAN", "code": "PAKISTAN" },
  { "id": 168, "name": "PALAU", "code": "PALAU" },
  { "id": 169, "name": "PALESTINIAN TERRITORY, OCCUPIED", "code": "PALESTINIAN TERRITORY, OCCUPIED" },
  { "id": 170, "name": "PANAMA", "code": "PANAMA" },
  { "id": 171, "name": "PAPUA NEW GUINEA", "code": "PAPUA NEW GUINEA" },
  { "id": 172, "name": "PARAGUAY", "code": "PARAGUAY" },
  { "id": 173, "name": "PERU", "code": "PERU" },
  { "id": 174, "name": "PHILIPPINES", "code": "PHILIPPINES" },
  { "id": 175, "name": "PITCAIRN", "code": "PITCAIRN" },
  { "id": 176, "name": "POLAND", "code": "POLAND" },
  { "id": 177, "name": "PORTUGAL", "code": "PORTUGAL" },
  { "id": 178, "name": "PUERTO RICO", "code": "PUERTO RICO" },
  { "id": 179, "name": "QATAR", "code": "QATAR" },
  { "id": 180, "name": "RÉUNION", "code": "RÉUNION" },
  { "id": 181, "name": "ROMANIA", "code": "ROMANIA" },
  { "id": 182, "name": "RUSSIAN FEDERATION", "code": "RUSSIAN FEDERATION" },
  { "id": 183, "name": "RWANDA", "code": "RWANDA" },
  { "id": 184, "name": "SAINT BARTHÉLEMY", "code": "SAINT BARTHÉLEMY" },
  { "id": 185, "name": "SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA", "code": "SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA" },
  { "id": 186, "name": "SAINT KITTS AND NEVIS", "code": "SAINT KITTS AND NEVIS" },
  { "id": 187, "name": "SAINT LUCIA", "code": "SAINT LUCIA" },
  { "id": 188, "name": "SAINT MARTIN", "code": "SAINT MARTIN" },
  { "id": 189, "name": "SAINT PIERRE AND MIQUELON", "code": "SAINT PIERRE AND MIQUELON" },
  { "id": 190, "name": "SAINT VINCENT AND THE GRENADINES", "code": "SAINT VINCENT AND THE GRENADINES" },
  { "id": 191, "name": "SAMOA", "code": "SAMOA" },
  { "id": 192, "name": "SAN MARINO", "code": "SAN MARINO" },
  { "id": 193, "name": "SAO TOME AND PRINCIPE", "code": "SAO TOME AND PRINCIPE" },
  { "id": 194, "name": "SAUDI ARABIA", "code": "SAUDI ARABIA" },
  { "id": 195, "name": "SENEGAL", "code": "SENEGAL" },
  { "id": 196, "name": "SERBIA", "code": "SERBIA" },
  { "id": 197, "name": "SEYCHELLES", "code": "SEYCHELLES" },
  { "id": 198, "name": "SIERRA LEONE", "code": "SIERRA LEONE" },
  { "id": 199, "name": "SINGAPORE", "code": "SINGAPORE" },
  { "id": 200, "name": "SLOVAKIA", "code": "SLOVAKIA" },
  { "id": 201, "name": "SLOVENIA", "code": "SLOVENIA" },
  { "id": 202, "name": "SOLOMON ISLANDS", "code": "SOLOMON ISLANDS" },
  { "id": 203, "name": "SOMALIA", "code": "SOMALIA" },
  { "id": 204, "name": "SOUTH AFRICA", "code": "SOUTH AFRICA" },
  { "id": 205, "name": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS", "code": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS" },
  { "id": 206, "name": "SPAIN", "code": "SPAIN" },
  { "id": 207, "name": "SRI LANKA", "code": "SRI LANKA" },
  { "id": 208, "name": "SUDAN", "code": "SUDAN" },
  { "id": 209, "name": "SURINAME", "code": "SURINAME" },
  { "id": 210, "name": "SVALBARD AND JAN MAYEN", "code": "SVALBARD AND JAN MAYEN" },
  { "id": 211, "name": "SWAZILAND", "code": "SWAZILAND" },
  { "id": 212, "name": "SWEDEN", "code": "SWEDEN" },
  { "id": 213, "name": "SWITZERLAND", "code": "SWITZERLAND" },
  { "id": 214, "name": "SYRIAN ARAB REPUBLIC", "code": "SYRIAN ARAB REPUBLIC" },
  { "id": 215, "name": "TAIWAN, PROVINCE OF CHINA", "code": "TAIWAN, PROVINCE OF CHINA" },
  { "id": 216, "name": "TAJIKISTAN", "code": "TAJIKISTAN" },
  { "id": 217, "name": "TANZANIA, UNITED REPUBLIC OF", "code": "TANZANIA, UNITED REPUBLIC OF" },
  { "id": 218, "name": "THAILAND", "code": "THAILAND" },
  { "id": 219, "name": "TIMOR-LESTE", "code": "TIMOR-LESTE" },
  { "id": 220, "name": "TOGO", "code": "TOGO" },
  { "id": 221, "name": "TOKELAU", "code": "TOKELAU" },
  { "id": 222, "name": "TONGA", "code": "TONGA" },
  { "id": 223, "name": "TRINIDAD AND TOBAGO", "code": "TRINIDAD AND TOBAGO" },
  { "id": 224, "name": "TUNISIA", "code": "TUNISIA" },
  { "id": 225, "name": "TURKEY", "code": "TURKEY" },
  { "id": 226, "name": "TURKMENISTAN", "code": "TURKMENISTAN" },
  { "id": 227, "name": "TURKS AND CAICOS ISLANDS", "code": "TURKS AND CAICOS ISLANDS" },
  { "id": 228, "name": "TUVALU", "code": "TUVALU" },
  { "id": 229, "name": "UGANDA", "code": "UGANDA" },
  { "id": 230, "name": "UKRAINE", "code": "UKRAINE" },
  { "id": 231, "name": "UNITED ARAB EMIRATES", "code": "UNITED ARAB EMIRATES" },
  { "id": 232, "name": "UNITED KINGDOM", "code": "UNITED KINGDOM" },
  { "id": 233, "name": "UNITED STATES", "code": "UNITED STATES" },
  { "id": 234, "name": "UNITED STATES MINOR OUTLYING ISLANDS", "code": "UNITED STATES MINOR OUTLYING ISLANDS" },
  { "id": 235, "name": "URUGUAY", "code": "URUGUAY" },
  { "id": 236, "name": "UZBEKISTAN", "code": "UZBEKISTAN" },
  { "id": 237, "name": "VANUATU", "code": "VANUATU" },
  { "id": 238, "name": "VATICAN CITY STATE", "code": "VATICAN CITY STATE" },
  { "id": 239, "name": "VENEZUELA, BOLIVARIAN REPUBLIC OF", "code": "VENEZUELA, BOLIVARIAN REPUBLIC OF" },
  { "id": 240, "name": "VIET NAM", "code": "VIET NAM" },
  { "id": 241, "name": "VIRGIN ISLANDS, BRITISH", "code": "VIRGIN ISLANDS, BRITISH" },
  { "id": 242, "name": "VIRGIN ISLANDS, U.S.", "code": "VIRGIN ISLANDS, U.S." },
  { "id": 243, "name": "WALLIS AND FUTUNA", "code": "WALLIS AND FUTUNA" },
  { "id": 244, "name": "WESTERN SAHARA", "code": "WESTERN SAHARA" },
  { "id": 245, "name": "YEMEN", "code": "YEMEN" },
  { "id": 246, "name": "ZAMBIA", "code": "ZAMBIA" },
  { "id": 247, "name": "ZIMBABWE", "code": "ZIMBABWE" }
]

export const CountriesListMappedById = () => {
  let countryList:{
    [key:number | string]: string
  } = {};
  CountriesList.forEach(i => {
    countryList[i.id] = i.name
  });

  return countryList;
}

export const NationalitiesList = [
  { id: 1, name: 'NIGERIAN', countryFk: 1 },
  { id: 2, name: 'AFGHAN', countryFk: 2 },
  { id: 3, name: 'ÅLAND ISLANDER', countryFk: 3 },
  { id: 4, name: 'ALBANIAN', countryFk: 4 },
  { id: 5, name: 'ALGERIAN', countryFk: 5 },
  { id: 6, name: 'AMERICAN SAMOAN', countryFk: 6 },
  { id: 7, name: 'ANDORRAN', countryFk: 7 },
  { id: 8, name: 'ANGOLAN', countryFk: 8 },
  { id: 9, name: 'ANGUILLIAN', countryFk: 9 },
  { id: 10, name: 'ANTARCTIC', countryFk: 10 },
  { id: 11, name: 'ANTIGUAN', countryFk: 11 },
  { id: 12, name: 'ARGENTINIAN', countryFk: 12 },
  { id: 13, name: 'ARMENIAN', countryFk: 13 },
  { id: 14, name: 'ARUBAN', countryFk: 14 },
  { id: 15, name: 'AUSTRALIAN', countryFk: 15 },
  { id: 16, name: 'AUSTRIAN', countryFk: 16 },
  { id: 17, name: 'AZERBAIJANI', countryFk: 17 },
  { id: 18, name: 'BAHAMIAN', countryFk: 18 },
  { id: 19, name: 'BAHRAINI', countryFk: 19 },
  { id: 20, name: 'BANGLADESHI', countryFk: 20 },
  { id: 21, name: 'BARBADIAN', countryFk: 21 },
  { id: 22, name: 'BELARUSIAN', countryFk: 22 },
  { id: 23, name: 'BELGIAN', countryFk: 23 },
  { id: 24, name: 'BELIZEAN', countryFk: 24 },
  { id: 25, name: 'BENINESE', countryFk: 25 },
  { id: 26, name: 'BERMUDIAN', countryFk: 26 },
  { id: 27, name: 'BHUTANESE', countryFk: 27 },
  { id: 28, name: 'BOLIVIAN', countryFk: 28 },
  { id: 29, name: 'BOSNIAN', countryFk: 29 },
  { id: 30, name: 'BOTSWANAN', countryFk: 30 },
  { id: 31, name: 'BOUVET ISLANDER', countryFk: 31 },
  { id: 32, name: 'BRAZILIAN', countryFk: 32 },
  { id: 33, name: 'BRITISH INDIAN OCEAN TERRITORY RESIDENT', countryFk: 33 },
  { id: 34, name: 'BRUNEIAN', countryFk: 34 },
  { id: 35, name: 'BULGARIAN', countryFk: 35 },
  { id: 36, name: 'BURKINABE', countryFk: 36 },
  { id: 37, name: 'BURUNDIAN', countryFk: 37 },
  { id: 38, name: 'CAMBODIAN', countryFk: 38 },
  { id: 39, name: 'CAMEROONIAN', countryFk: 39 },
  { id: 40, name: 'CANADIAN', countryFk: 40 },
  { id: 41, name: 'CAPE VERDEAN', countryFk: 41 },
  { id: 42, name: 'CAYMANIAN', countryFk: 42 },
  { id: 43, name: 'CENTRAL AFRICAN', countryFk: 43 },
  { id: 44, name: 'CHADIAN', countryFk: 44 },
  { id: 45, name: 'CHILEAN', countryFk: 45 },
  { id: 46, name: 'CHINESE', countryFk: 46 },
  { id: 47, name: 'CHRISTMAS ISLANDER', countryFk: 47 },
  { id: 48, name: 'COCOS ISLANDER', countryFk: 48 },
  { id: 49, name: 'COLOMBIAN', countryFk: 49 },
  { id: 50, name: 'COMORAN', countryFk: 50 },
  { id: 51, name: 'CONGOLESE', countryFk: 51 },
  { id: 52, name: 'CONGOLESE', countryFk: 52 },
  { id: 53, name: 'COOK ISLANDER', countryFk: 53 },
  { id: 54, name: 'COSTA RICAN', countryFk: 54 },
  { id: 55, name: 'CÔTE D’IVOIRE NATIONAL', countryFk: 55 },
  { id: 56, name: 'CROATIAN', countryFk: 56 },
  { id: 57, name: 'CUBAN', countryFk: 57 },
  { id: 58, name: 'CYPRIOT', countryFk: 58 },
  { id: 59, name: 'CZECH', countryFk: 59 },
  { id: 60, name: 'DANISH', countryFk: 60 },
  { id: 61, name: 'DJIBOUTIAN', countryFk: 61 },
  { id: 62, name: 'DOMINICAN (DOMINICA)', countryFk: 62 },
  { id: 63, name: 'DOMINICAN', countryFk: 63 },
  { id: 64, name: 'ECUADORIAN', countryFk: 64 },
  { id: 65, name: 'EGYPTIAN', countryFk: 65 },
  { id: 66, name: 'SALVADORAN', countryFk: 66 },
  { id: 67, name: 'EQUATORIAL GUINEAN', countryFk: 67 },
  { id: 68, name: 'ERITREAN', countryFk: 68 },
  { id: 69, name: 'ESTONIAN', countryFk: 69 },
  { id: 70, name: 'ETHIOPIAN', countryFk: 70 },
  { id: 71, name: 'FALKLAND ISLANDER', countryFk: 71 },
  { id: 72, name: 'FAROESE', countryFk: 72 },
  { id: 73, name: 'FIJIAN', countryFk: 73 },
  { id: 74, name: 'FINNISH', countryFk: 74 },
  { id: 75, name: 'FRENCH', countryFk: 75 },
  { id: 76, name: 'FRENCH GUIANAN', countryFk: 76 },
  { id: 77, name: 'FRENCH POLYNESIAN', countryFk: 77 },
  { id: 78, name: 'FRENCH SOUTHERN TERRITORIES RESIDENT', countryFk: 78 },
  { id: 79, name: 'GABONESE', countryFk: 79 },
  { id: 80, name: 'GAMBIAN', countryFk: 80 },
  { id: 81, name: 'GEORGIAN', countryFk: 81 },
  { id: 82, name: 'GERMAN', countryFk: 82 },
  { id: 83, name: 'GHANAIAN', countryFk: 83 },
  { id: 84, name: 'GIBRALTARIAN', countryFk: 84 },
  { id: 85, name: 'GREEK', countryFk: 85 },
  { id: 86, name: 'GREENLANDIC', countryFk: 86 },
  { id: 87, name: 'GRENADIAN', countryFk: 87 },
  { id: 88, name: 'GUADELOUPAN', countryFk: 88 },
  { id: 89, name: 'GUAMANIAN', countryFk: 89 },
  { id: 90, name: 'GUATEMALAN', countryFk: 90 },
  { id: 91, name: 'GUERNSEY RESIDENT', countryFk: 91 },
  { id: 92, name: 'GUINEAN', countryFk: 92 },
  { id: 93, name: 'GUINEA‑BISSAU NATIONAL', countryFk: 93 },
  { id: 94, name: 'GUYANESE', countryFk: 94 },
  { id: 95, name: 'HAITIAN', countryFk: 95 },
  { id: 96, name: 'HEARD ISLANDER', countryFk: 96 },
  { id: 97, name: 'VATICAN', countryFk: 97 },
  { id: 98, name: 'HONDURAN', countryFk: 98 },
  { id: 99, name: 'HONG KONGER', countryFk: 99 },
  { id: 100, name: 'HUNGARIAN', countryFk: 100 },
  { id: 101, name: 'ICELANDIC', countryFk: 101 },
  { id: 102, name: 'INDIAN', countryFk: 102 },
  { id: 103, name: 'INDONESIAN', countryFk: 103 },
  { id: 104, name: 'IRANIAN', countryFk: 104 },
  { id: 105, name: 'IRAQI', countryFk: 105 },
  { id: 106, name: 'IRISH', countryFk: 106 },
  { id: 107, name: 'ISLE OF MAN RESIDENT', countryFk: 107 },
  { id: 108, name: 'ISRAELI', countryFk: 108 },
  { id: 109, name: 'ITALIAN', countryFk: 109 },
  { id: 110, name: 'JAMAICAN', countryFk: 110 },
  { id: 111, name: 'JAPANESE', countryFk: 111 },
  { id: 112, name: 'JERSEY RESIDENT', countryFk: 112 },
  { id: 113, name: 'JORDANIAN', countryFk: 113 },
  { id: 114, name: 'KAZAKHSTANI', countryFk: 114 },
  { id: 115, name: 'KENYAN', countryFk: 115 },
  { id: 116, name: 'KIRIBATIAN', countryFk: 116 },
  { id: 117, name: 'NORTH KOREAN', countryFk: 117 },
  { id: 118, name: 'SOUTH KOREAN', countryFk: 118 },
  { id: 119, name: 'KUWAITI', countryFk: 119 },
  { id: 120, name: 'KYRGYZ', countryFk: 120 },
  { id: 121, name: 'LAO', countryFk: 121 },
  { id: 122, name: 'LATVIAN', countryFk: 122 },
  { id: 123, name: 'LEBANESE', countryFk: 123 },
  { id: 124, name: 'LESOTHOAN', countryFk: 124 },
  { id: 125, name: 'LIBERIAN', countryFk: 125 },
  { id: 126, name: 'LIBYAN', countryFk: 126 },
  { id: 127, name: 'LIECHTENSTEINER', countryFk: 127 },
  { id: 128, name: 'LITHUANIAN', countryFk: 128 },
  { id: 129, name: 'LUXEMBOURGER', countryFk: 129 },
  { id: 130, name: 'MACANESE', countryFk: 130 },
  { id: 131, name: 'MACEDONIAN', countryFk: 131 },
  { id: 132, name: 'MADAGASCARAN', countryFk: 132 },
  { id: 133, name: 'MALAWIAN', countryFk: 133 },
  { id: 134, name: 'MALAYSIAN', countryFk: 134 },
  { id: 135, name: 'MALDIVIAN', countryFk: 135 },
  { id: 136, name: 'MALIAN', countryFk: 136 },
  { id: 137, name: 'MALTESE', countryFk: 137 },
  { id: 138, name: 'MARSHALL ISLANDER', countryFk: 138 },
  { id: 139, name: 'MARTINIQUAIS', countryFk: 139 },
  { id: 140, name: 'MAURITANIAN', countryFk: 140 },
  { id: 141, name: 'MAURITIAN', countryFk: 141 },
  { id: 142, name: 'MAYOTTE RESIDENT', countryFk: 142 },
  { id: 143, name: 'MEXICAN', countryFk: 143 },
  { id: 144, name: 'MICRONESIAN', countryFk: 144 },
  { id: 145, name: 'MOLDOVAN', countryFk: 145 },
  { id: 146, name: 'MONÉGASQUE', countryFk: 146 },
  { id: 147, name: 'MONGOLIAN', countryFk: 147 },
  { id: 148, name: 'MONTENEGRIN', countryFk: 148 },
  { id: 149, name: 'MONTSERRATIAN', countryFk: 149 },
  { id: 150, name: 'MOROCCAN', countryFk: 150 },
  { id: 151, name: 'MOZAMBICAN', countryFk: 151 },
  { id: 152, name: 'MYANMARIAN', countryFk: 152 },
  { id: 153, name: 'NAMIBIAN', countryFk: 153 },
  { id: 154, name: 'NAURUAN', countryFk: 154 },
  { id: 155, name: 'NEPALESE', countryFk: 155 },
  { id: 156, name: 'DUTCH', countryFk: 156 },
  { id: 157, name: 'DUTCH ANTILLEAN', countryFk: 157 },
  { id: 158, name: 'NEW CALEDONIAN', countryFk: 158 },
  { id: 159, name: 'NEW ZEALANDER', countryFk: 159 },
  { id: 160, name: 'NICARAGUAN', countryFk: 160 },
  { id: 161, name: 'NIGERIEN', countryFk: 161 },
  { id: 162, name: 'NIUEAN', countryFk: 162 },
  { id: 163, name: 'NORFOLK ISLANDER', countryFk: 163 },
  { id: 164, name: 'NORTHERN MARIANA ISLANDER', countryFk: 164 },
  { id: 165, name: 'NORWEGIAN', countryFk: 165 },
  { id: 166, name: 'OMANI', countryFk: 166 },
  { id: 167, name: 'PAKISTANI', countryFk: 167 },
  { id: 168, name: 'PALAUN', countryFk: 168 },
  { id: 169, name: 'PALESTINIAN', countryFk: 169 },
  { id: 170, name: 'PANAMANIAN', countryFk: 170 },
  { id: 171, name: 'PAPUA NEW GUINEAN', countryFk: 171 },
  { id: 172, name: 'PARAGUAYAN', countryFk: 172 },
  { id: 173, name: 'PERUVIAN', countryFk: 173 },
  { id: 174, name: 'PHILIPPINE', countryFk: 174 },
  { id: 175, name: 'PITCAIRN ISLANDER', countryFk: 175 },
  { id: 176, name: 'POLISH', countryFk: 176 },
  { id: 177, name: 'PORTUGUESE', countryFk: 177 },
  { id: 178, name: 'PUERTO RICAN', countryFk: 178 },
  { id: 179, name: 'QATARI', countryFk: 179 },
  { id: 180, name: 'RÉUNIONNAIS', countryFk: 180 },
  { id: 181, name: 'ROMANIAN', countryFk: 181 },
  { id: 182, name: 'RUSSIAN', countryFk: 182 },
  { id: 183, name: 'RWANDAN', countryFk: 183 },
  { id: 184, name: 'SAINT BARTHÉLEMY RESIDENT', countryFk: 184 },
  { id: 185, name: 'SAINT HELENA RESIDENT', countryFk: 185 },
  { id: 186, name: 'SAINT KITTS AND NEVIS NATIONAL', countryFk: 186 },
  { id: 187, name: 'SAINT LUCIAN', countryFk: 187 },
  { id: 188, name: 'SAINT MARTINOIS', countryFk: 188 },
  { id: 189, name: 'SAINT PIERREAN', countryFk: 189 },
  { id: 190, name: 'SAINT VINCENTIAN', countryFk: 190 },
  { id: 191, name: 'SAMOAN', countryFk: 191 },
  { id: 192, name: 'SAN MARINESE', countryFk: 192 },
  { id: 193, name: 'SAO TOMEAN', countryFk: 193 },
  { id: 194, name: 'SAUDI', countryFk: 194 },
  { id: 195, name: 'SENEGALESE', countryFk: 195 },
  { id: 196, name: 'SERBIAN', countryFk: 196 },
  { id: 197, name: 'SEYCHELLOIS', countryFk: 197 },
  { id: 198, name: 'SIERRA LEONEAN', countryFk: 198 },
  { id: 199, name: 'SINGAPOREAN', countryFk: 199 },
  { id: 200, name: 'SLOVAK', countryFk: 200 },
  { id: 201, name: 'SLOVENIAN', countryFk: 201 },
  { id: 202, name: 'SOLOMON ISLANDER', countryFk: 202 },
  { id: 203, name: 'SOMALIAN', countryFk: 203 },
  { id: 204, name: 'SOUTH AFRICAN', countryFk: 204 },
  { id: 205, name: 'SOUTH GEORGIA RESIDENT', countryFk: 205 },
  { id: 206, name: 'SPANISH', countryFk: 206 },
  { id: 207, name: 'SRI LANKAN', countryFk: 207 },
  { id: 208, name: 'SUDANESE', countryFk: 208 },
  { id: 209, name: 'SURINAMESE', countryFk: 209 },
  { id: 210, name: 'SVALBARDIAN', countryFk: 210 },
  { id: 211, name: 'SWAZI', countryFk: 211 },
  { id: 212, name: 'SWEDISH', countryFk: 212 },
  { id: 213, name: 'SWISS', countryFk: 213 },
  { id: 214, name: 'SYRIAN', countryFk: 214 },
  { id: 215, name: 'TAIWANESE', countryFk: 215 },
  { id: 216, name: 'TAJIKISTANI', countryFk: 216 },
  { id: 217, name: 'TANZANIAN', countryFk: 217 },
  { id: 218, name: 'THAI', countryFk: 218 },
  { id: 219, name: 'TIMORESE', countryFk: 219 },
  { id: 220, name: 'TOGOLESE', countryFk: 220 },
  { id: 221, name: 'TOKELAUAN', countryFk: 221 },
  { id: 222, name: 'TONGAN', countryFk: 222 },
  { id: 223, name: 'TRINIDADIAN', countryFk: 223 },
  { id: 224, name: 'TUNISIAN', countryFk: 224 },
  { id: 225, name: 'TURKISH', countryFk: 225 },
  { id: 226, name: 'TURKMEN', countryFk: 226 },
  { id: 227, name: 'TURKS AND CAICOS ISLANDER', countryFk: 227 },
  { id: 228, name: 'TUVALUAN', countryFk: 228 },
  { id: 229, name: 'UGANDAN', countryFk: 229 },
  { id: 230, name: 'UKRAINIAN', countryFk: 230 },
  { id: 231, name: 'EMIRATI', countryFk: 231 },
  { id: 232, name: 'BRITISH', countryFk: 232 },
  { id: 233, name: 'AMERICAN', countryFk: 233 },
  { id: 234, name: 'US MINOR OUTLYING ISLANDS RESIDENT', countryFk: 234 },
  { id: 235, name: 'URUGUAYAN', countryFk: 235 },
  { id: 236, name: 'UZBEK', countryFk: 236 },
  { id: 237, name: 'VANUATUAN', countryFk: 237 },
  { id: 238, name: 'VATICAN', countryFk: 238 },
  { id: 239, name: 'VENEZUELAN', countryFk: 239 },
  { id: 240, name: 'VIETNAMESE', countryFk: 240 },
  { id: 241, name: 'BRITISH VIRGIN ISLANDER', countryFk: 241 },
  { id: 242, name: 'AMERICAN VIRGIN ISLANDER', countryFk: 242 },
  { id: 243, name: 'WALLIS AND FUTUNA RESIDENT', countryFk: 243 },
  { id: 244, name: 'WESTERN SAHARAN', countryFk: 244 },
  { id: 245, name: 'YEMENI', countryFk: 245 },
  { id: 246, name: 'ZAMBIAN', countryFk: 246 },
  { id: 247, name: 'ZIMBABWEAN', countryFk: 247 }
];


export const getCountryById = (id:any) => {
  return CountriesList.find(c => `${c.id}` === `${id}`)
}
export const getCountryByName = (name:any) => {
  return CountriesList.find(c => `${c.name}` === `${name}`)
}
